import { del, get, post } from './base'
import type { Disk, DiskListResponse } from '@/models/ecs'
import { getUserList } from '@/service/bills'
import type { User } from '@/models/user'
import { toStandardUUIDFormat } from '@/utils'

export const createDisk = (params: Record<string, any>) => {
  return post('disks', { body: params })
}

export const fetchDiskList = ({ params }: { params: Record<string, any> }) => {
  return get<DiskListResponse>('disks', { params })
}

export const deleteDisk = (id: string) => {
  return del(`disks/${id}`)
}

export const fetchDisk = (id: string) => {
  return get(`disks/${id}`)
}

export const updateDisk = (id: string, params: Record<string, any>) => {
  return post(`disks/${id}`, { body: params })
}

export const fetchDiskListWithUser = async ({
  params,
}: Record<string, any>) => {
  const [disks, users] = await Promise.all([
    fetchDiskList({ params }),
    getUserList({}),
  ])
  return {
    data: disks.data.map((disk: Disk) => ({
      ...disk,
      created_by_user: users.data.find(
        (u: User) => toStandardUUIDFormat(u.id) === disk.created_by,
      ),
    })),
    limit: disks.limit,
    page: disks.page,
    total: disks.total,
  } as DiskListResponse
}
